import service from '@/services/accounting-current-context-service'
import { contextDate } from '@/models/accounting-current-context'

export function createAccountingContextModule(api) {
  let pending = null
  return {
    namespaced:true,
    state:() => ({ data:null, identity:'', loading:false, error:'', loadedAt:0, requestId:0 }),
    mutations:{
      reset(state) { state.requestId++;state.data=null;state.identity='';state.error='';state.loadedAt=0;state.loading=false },
      begin(state, identity) { state.requestId++;if (state.identity!==identity) state.data=null;state.identity=identity;state.loading=true;state.error='' },
      success(state, data) { state.data=data;state.loading=false;state.error='';state.loadedAt=Date.now() },
      failure(state) { state.data=null;state.loading=false;state.error='Tanggal dan periode belum dapat dimuat.';state.loadedAt=0 },
    },
    actions:{
      load({state,commit,rootState}, {force=false}={}) {
        const user=rootState.auth?.user
        if (!user) { commit('reset');return Promise.resolve(null) }
        const identity=`${user.id}:${user.fcompanyBean || ''}`
        if (pending?.identity===identity && state.loading) return pending.promise
        if (!force && state.identity===identity && state.data && Date.now()-state.loadedAt<60000) return Promise.resolve(state.data)
        commit('begin',identity)
        const requestId=state.requestId
        const promise=api.current().then(({data}) => {
          if (requestId!==state.requestId || identity!==`${rootState.auth?.user?.id}:${rootState.auth?.user?.fcompanyBean || ''}`) return null
          const expectedCompany = Number(user.fcompanyBean || 0)
          if ((expectedCompany > 0 && data?.companyId !== expectedCompany) || !data?.companyId || data.companyId <= 0 || contextDate(data?.calendarDate)==='—') throw new Error('Invalid accounting context')
          commit('success',data);return data
        }).catch(() => { if (requestId===state.requestId) commit('failure');return null })
          .finally(() => { if (pending?.promise===promise) pending=null })
        pending={identity,promise};return promise
      },
    },
  }
}
export const accountingContext = createAccountingContextModule(service)
